import { render } from "./CappStatement.vue?vue&type=template&id=344f6e7a&scoped=true&ts=true"
import script from "./CappStatement.vue?vue&type=script&lang=ts"
export * from "./CappStatement.vue?vue&type=script&lang=ts"

import "./CappStatement.vue?vue&type=style&index=0&id=344f6e7a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344f6e7a"]])

export default __exports__